export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"},{"charset":"utf-8"},{"name":"referrer","content":"origin-when-cross-origin"},{"name":"apple-mobile-web-app-title","content":"Elle Midwives - Empowering modern moms from bump to baby"},{"name":"application-name","content":"Elle Midwives - Empowering modern moms from bump to baby"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"theme-color","content":"#F0E9E4"}],"link":[{"sizes":"57x57","rel":"apple-touch-icon","href":"/favicons/apple-icon-57x57.png"},{"sizes":"60x60","rel":"apple-touch-icon","href":"/favicons/apple-icon-60x60.png"},{"sizes":"72x72","rel":"apple-touch-icon","href":"/favicons/apple-icon-72x72.png"},{"sizes":"76x76","rel":"apple-touch-icon","href":"/favicons/apple-icon-76x76.png"},{"sizes":"114x114","rel":"apple-touch-icon","href":"/favicons/apple-icon-114x114.png"},{"sizes":"120x120","rel":"apple-touch-icon","href":"/favicons/apple-icon-120x120.png"},{"sizes":"144x144","rel":"apple-touch-icon","href":"/favicons/apple-icon-144x144.png"},{"sizes":"152x152","rel":"apple-touch-icon","href":"/favicons/apple-icon-152x152.png"},{"sizes":"180x180","rel":"apple-touch-icon","href":"/favicons/apple-icon-180x180.png"},{"sizes":"192x192","type":"image/png","rel":"icon","href":"/favicons/android-icon-192x192.png"},{"sizes":"144x144","type":"image/png","rel":"icon","href":"/favicons/android-icon-144x144.png"},{"sizes":"96x96","type":"image/png","rel":"icon","href":"/favicons/android-icon-96x96.png"},{"sizes":"72x72","type":"image/png","rel":"icon","href":"/favicons/android-icon-72x72.png"},{"sizes":"48x48","type":"image/png","rel":"icon","href":"/favicons/android-icon-48x48.png"},{"sizes":"36x36","type":"image/png","rel":"icon","href":"/favicons/android-icon-36x36.png"},{"sizes":"16x16","type":"image/png","rel":"icon","href":"/favicons/favicon-16x16.png"},{"sizes":"32x32","type":"image/png","rel":"icon","href":"/favicons/favicon-32x32.png"},{"sizes":"96x96","type":"image/png","rel":"icon","href":"/favicons/favicon-96x96.png"},{"sizes":"70x70","type":"image/png","rel":"icon","href":"/favicons/ms-icon-70x70.png"},{"sizes":"144x144","type":"image/png","rel":"icon","href":"/favicons/ms-icon-144x144.png"},{"sizes":"150x150","type":"image/png","rel":"icon","href":"/favicons/ms-icon-150x150.png"},{"sizes":"310x310","type":"image/png","rel":"icon","href":"/favicons/ms-icon-310x310.png"},{"rel":"manifest","href":"/manifest.webmanifest"},{"rel":"dns-prefetch","href":"https://www.googletagmanager.com"},{"rel":"dns-prefetch","href":"https://www.google-analytics.com"}],"style":[],"script":[],"noscript":[{"innerHTML":"<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-WNHBXJ4\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>"}],"title":"Elle Midwives","charset":"utf-8","viewport":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover","htmlAttrs":{"lang":"nl"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true